import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchBeat, updateBeat, Note, BeatLevel } from "./beatApi";
import styles from "./BeatShared.module.css";

export default function EditBeat() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [bpm, setBpm] = useState(120);
  const [rhythm, setRhythm] = useState("4/4");
  const [level, setLevel] = useState<BeatLevel>(BeatLevel.beginner);
  const [duration, setDuration] = useState(0);
  const [fileUrl, setFileUrl] = useState("");
  const [notesRaw, setNotesRaw] = useState<string>("[]");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) loadBeat(id);
  }, [id]);

  const loadBeat = async (beatId: string) => {
    try {
      const data = await fetchBeat(beatId);
      console.log("📝 Beat data received:", data);

      if (!data) {
        throw new Error("Beat bulunamadı");
      }

      setTitle(data.title || "");
      setBpm(data.bpm || 120);
      setRhythm(data.rhythm || "4/4");
      setLevel((data.genre as BeatLevel) || BeatLevel.beginner); // genre'yi level olarak kullan
      setDuration(data.duration_seconds || 0);
      setFileUrl(data.file_url || "");
      setNotesRaw(data.notes || "[]"); // notes artık string
    } catch (error) {
      console.error("Beat yükleme hatası:", error);
      alert("Beat bilgisi yüklenemedi: " + (error as Error).message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) return;

    if (!title || !fileUrl || !rhythm || !duration || !bpm || !level) {
      alert("Tüm alanlar zorunludur.");
      return;
    }

    let notes: Note[] = [];
    if (notesRaw && notesRaw.trim() !== "" && notesRaw.trim() !== "[]") {
      try {
        const parsed = JSON.parse(notesRaw);
        if (!Array.isArray(parsed))
          throw new Error("Note JSON dizisi geçersiz");
        notes = parsed;
      } catch (err) {
        alert("Notes JSON formatı hatalı: " + err);
        return;
      }
    }

    try {
      await updateBeat(id, {
        title,
        bpm,
        rhythm,
        genre: level as string, // level'i genre olarak kullan
        duration_seconds: duration,
        file_url: fileUrl,
        notes: JSON.stringify(notes), // notes'u string'e çevir
      });
      navigate("/beats");
    } catch (error) {
      alert("Güncelleme sırasında hata oluştu.");
      console.error(error);
    }
  };

  if (loading) return <div className={styles.loading}>Yükleniyor...</div>;

  return (
    <div className={styles.tableContainer}>
      <h1 className={styles.title}>
        <span role="img" aria-label="kalem">
          ✏️
        </span>{" "}
        Beat Güncelle
      </h1>
      <form onSubmit={handleSubmit} className={styles.form}>
        <div>
          <label className={styles.label}>Başlık</label>
          <input
            className={styles.input}
            value={title}
            onChange={(e) => setTitle(e.target.value || "")}
            required
          />
        </div>
        <div className={styles.grid2}>
          <div>
            <label className={styles.label}>BPM</label>
            <input
              type="number"
              className={styles.input}
              value={bpm}
              min="60"
              max="200"
              onChange={(e) => setBpm(parseInt(e.target.value) || 120)}
              required
            />
          </div>
          <div>
            <label className={styles.label}>Ritim</label>
            <input
              className={styles.input}
              value={rhythm}
              onChange={(e) => setRhythm(e.target.value || "")}
              required
            />
          </div>
          <div>
            <label className={styles.label}>Seviye</label>
            <select
              className={styles.input}
              value={level}
              onChange={(e) => setLevel(e.target.value as BeatLevel)}
              required
            >
              {Object.values(BeatLevel).map((lvl) => (
                <option key={lvl} value={lvl}>
                  {lvl}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className={styles.label}>Süre (saniye)</label>
            <input
              type="number"
              className={styles.input}
              value={duration}
              min="1"
              max="600"
              onChange={(e) => setDuration(parseInt(e.target.value) || 0)}
              required
            />
          </div>
        </div>
        <div>
          <label className={styles.label}>Dosya Bağlantısı</label>
          <input
            className={styles.input}
            value={fileUrl}
            onChange={(e) => setFileUrl(e.target.value || "")}
            required
          />
        </div>
        <div>
          <label className={styles.label}>
            Notes (JSON formatında - isteğe bağlı)
          </label>
          <textarea
            className={styles.input}
            style={{ height: "150px", fontFamily: "monospace" }}
            value={notesRaw}
            onChange={(e) => setNotesRaw(e.target.value)}
            placeholder='Boş bırakabilir veya şu formatta girebilirsiniz: [{"i":1,"sM":100,"eM":200,"led":[1,2]}]'
          />
        </div>
        <button className={styles.button}>Güncelle</button>
      </form>
    </div>
  );
}
